<template>
  <div
    class="popup popup-outer"
    @click.self="close"
  >
    <slot name="before" />

    <div
      class="popup-inner"
      :class="innerClass"
      @mouseover="hovering = true"
      @mouseleave="hovering = false"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    innerClass: {
      type: String,
      default: '',
    },
  },

  emits: ['close', 'left', 'right'],

  data() {
    return {
      hovering: false,
    };
  },
  mounted() {
    document.body.classList.add('!overflow-hidden');
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.body.classList.remove('!overflow-hidden');
    window.removeEventListener('keydown', this.handleKeydown);
  },

  methods: {
    close() {
      this.$emit('close', false);
    },

    handleKeydown(event) {
      if (event.keyCode === 37) {
        // left arrow key
        this.$emit('left');
      } else if (event.keyCode === 39) {
        // right arrow key
        this.$emit('right');
      } else if (event.keyCode === 27) {
        // escape key
        this.close();
      }
    },
  },
};
</script>

<style lang="scss">
@import './Popup.scss';
</style>
